import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Chip } from "@mui/material";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import ReactTable from "../../../../components/common/ReactTable";
import ApiCallService from "../../../../Service/ApiCallService";
import { usePermission } from "../../../../permissions/usePermission";
const ProfileUpdate = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { canByKey } = usePermission();
  const canApproveProfileUpdate = canByKey("USER_MANAGEMENT_USER_APPROVAL_APPROVE_UPDATE");
  const canDeclineProfileUpdate = canByKey("USER_MANAGEMENT_USER_APPROVAL_DECLINE_UPDATE");

  const fetchProfileUpdates = async () => {
    try {
      setLoading(true);
      const res = await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/ProfileUpdatesPending`
      );
      setRows(res.data || []);
    } catch (err) {
      setLoading(false)
      message.error("Failed to fetch profile update requests");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfileUpdates();
  }, []);

  const columns = [
    {
      field: "fullName",
      headerName: "Full Name",
      renderCell: (row) =>
        `${row.userFirstName} ${row.userLastName}`,
      searchKey: (row) =>
        `${row.userFirstName || ""} ${row.userMiddleName || ""} ${row.userLastName || ""}`,
    },
    {
      field: "mobileNumber",
      headerName: "Mobile Number",
    },
    {
      field: "requestedAt",
      headerName: "Requested On",
      renderCell: (row) =>
        new Date(row.updateRequestedAt).toLocaleString(),
    },
    // {
    //   field: "changes",
    //   headerName: "Changed Fields",
    //   disableSort: true,
    //   renderCell: (row) => (
    //     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
    //       {Object.keys(row.pendingUpdates || {}).map((key) => (
    //         <Chip
    //           key={key}
    //           label={key}
    //           size="small"
    //           color="warning"
    //         />
    //       ))}
    //     </Box>
    //   ),
    // },
    ...((canApproveProfileUpdate || canDeclineProfileUpdate)
      ? [
          {
            field: "actions",
            headerName: "Actions",
            disableSort: true,
            disableSearch: true,
            renderCell: (row) => (
              <Button
                variant="contained"
                color="primary"
                onClick={() =>
                  navigate(`/ProfileUpdateReview/${row._id}`)
                }
              >
                Review
              </Button>
            ),
          },
        ]
      : []),
  ];

  return (
    <Box>
    

      <ReactTable
        columns={columns}
        rows={rows}
        rowKey="_id"
        loading={loading}
      />
    </Box>
  );
};

export default ProfileUpdate;
